const scrollIn = (scrollPos,ms)=> {
    return new Promise((resolve,reject)=>{
        if (window.scrollY < scrollPos ) {
            slidingHeader.disable();
            scroll.scrollToY(scrollPos,ms);
            setTimeout(()=>{resolve('scroll is done')},ms+10);
        } else {
            reject('Window scroll Y is greater than or equal to ' + scrollPos);
        }
    });
}






